﻿
export enum RepStatusEnum {
  Neu = 100,
  EndkundeAngemeldet = 180,
  EndkundeAngemeldetLeerkarton = 185,
  LeerkartonAngefordert = 195,
  Leerkarton = 200,
  EinsendeetikettGesendetAngefordert = 205,
  EinsendeetikettGesendet = 210,
  Zulauf = 290,
  Eingelagert = 299,
  Wareneingang = 300,
  KVANeuErstellen = 305,
  HotlineGeparkt = 310,
  InPruefung = 320,
  KaufbelegFreigeben = 325,
  LagerGeparktKVA = 400,
  KVAGesendet = 410,
  RechnungAnfordern = 420,
  ZKD_Vorrauskassa = 430,
  KeineRückmeldungKVA1 = 440,
  KeineRückmeldungKVA2 = 441,
  Nachforschung = 450,
  LagerWarteschlange = 500,
  WartenAufMeister = 501,
  Reperatur = 600,
  Ruecklaeufer = 700,
  RueckgestelltSP = 790,
  Abgeschlossen = 800,
  AbgeschlossenUnerledigtRetour = 810,
  AbgeschlossenVerschrotten = 820,
  AbgeschlossenSPUngeprüft = 850,
  Archiviert = 901,
}
